import 'normalize.css';
import './fonts.css';
import './resets.css';
export var ThemeProvider = function (_a) {
    var children = _a.children;
    return children;
};
//# sourceMappingURL=resets.js.map